﻿export function initFa() {

    document.body.classList.add('jsActive');

    //Globals
    let sub = window.location.href.indexOf('/fa') > -1 ? '/fa' : '';
    let searchvalue = '';
    //Globals slut

    //Update---
    $('#update-button').on('click', function () {
        SetUpdate(1);
    });
    $('#notnow-button').on('click', function () {
        SetUpdate(0);
    });
    $('#hidemessage-button').on('click', function () {
        SetUpdate(2);
    });

    function SetUpdate(typ) {
        document.body.classList.add('busy-cursor');
        let url = sub + "/Update/SetUpdateFlag?typ=" + typ;
        switch (typ) {
            case 0:
                document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                break;
            case 1:
                {
                    document.getElementById("UpdateInfoContainerMain").classList.toggle("hide");
                    document.getElementById("UpdateInfoContainerResult").classList.toggle("hide");
                    setInterval(function () {
                        url = sub + "/Update/SyncStatus";
                        $.get(url)
                            .done(function (data) {
                                $('#updateOngoingInfo').text(data);
                            });
                    }, 5000);
                }
                break;
            case 2:
                document.getElementById("UpdateAppContainer").classList.toggle("hide");
                break;
        }

        $.post(url)
            .done(function (data) {
                document.body.classList.remove('busy-cursor');
                $("#UpdateContainer").hide();
                location.reload();
                document.body.classList.remove('busy-cursor');
            });

    }
    //Update----

    //Sök----
    $('#searchQuery').on("input", function () {
        if ($('#searchQuery').val() == '') {
            Clear();
        }
        else {
            searchvalue = $('#searchQuery').val();
        }

    });
    /*Uppstart*/
    $(document).ready(function () {
        let searchval = $('#searchQuery').val();
        if (!searchval) { Clear(); }
        $('#searchQuery').focus();

    });

    /*Rensar*/
    function Clear() {
        searchvalue = '';
        $('#search').val("");
        $('#searchDataContainer2').html("");
        $('#search').focus();
        $('#searchHelpContainer').show();
        $('#searchHeaderContainer2').show();
        $('#hitContainer').hide();
        $('#paginator').html("");

        $.get(sub + "/Home/ClearQuery", function (data) { });
    }

    // Hantering av fullt respektive avsklippt ämnespostnamn vid sticky scroll

    let compactSubstanceName = false;

    window.addEventListener("scroll", () => {
        const rect = document.getElementById("pageHeader").getBoundingClientRect();

        if (!compactSubstanceName && rect.bottom < 0) {
            compactSubstanceName = true;
            document.body.classList.add("scrolled");
            window.scrollTo({ top: -rect.top, behavior: "instant" }); // behövs för att motverka hopp
        }

        if (compactSubstanceName && rect.top == 0) {
            compactSubstanceName = false;
            document.body.classList.remove("scrolled");
            window.scrollTo({ top: 0, behavior: "instant" }); // behövs för att motverka hopp
        }
    });    


    // Hantering av flikväxling
    function showTab(id) {
        document.querySelectorAll("#mainContainer .ds-c-tabs__tabpanel").forEach(tabDiv => {
            tabDiv.hidden = tabDiv.id !== id;
        });
        document.querySelectorAll('nav[role="tablist"] a').forEach(a => {
            a.classList.toggle('active', a.hash === '#' + id);
        });
        if (document.getElementById(id) != null) {
            const tabDivRect = document.getElementById(id).getBoundingClientRect();
            const stickyTopRect = document.getElementById("stickyTop").getBoundingClientRect();
            if (tabDivRect.top < stickyTopRect.bottom) {
                const missingStickyHeader = stickyTopRect.top + 0.1;
                window.scrollBy({ top: tabDivRect.top - stickyTopRect.bottom + missingStickyHeader, behavior: "instant" });
            }
        }
    }

    document.querySelectorAll('nav[role="tablist"] a').forEach(a => {
        a.addEventListener('click', e => {
            e.preventDefault();
            showTab(a.hash.substring(1));
        });
    });

    showTab("IdentityTabPanel");
}